/* eslint-disable no-dupe-keys */
import React, { useEffect, useState } from "react";
import styles from "./specialneeds.module.scss";
import Layout from "partials/layout";
import { ERCText } from "components/text";
import CourseTags from "components/coursetags";
import SideFilter from "components/sidefilterr";
import RecommendedCourses from "components/recommendedcoursescard";
import CourseCardSmall from "components/studentcoursecardsm";
import art from "assets/images/arts.svg";
import sciences from "assets/images/sciences.svg";
import GamesCard from "components/gamescard";
import { ERCButton } from "components/button";
import FilterComponent from "components/filterComponent";
import { PaginationSection } from "components/pagination/newPagination";
import img1 from "../../../assets/images/government.png";
import img2 from "../../../assets/images/bookkeep.png";
import img3 from "../../../assets/images/chemistry.png";

const SpecialNeedsCourses = () => {
  const courses = [
    {
      img: "commercial.png",
      text: "Commercial",
      subject: "Art",
      // eslint-disable-next-line no-dupe-keys
      img: img1,
      category: "Educational Materials",
      title: "Mastering Commercial Skills for Success", // Added title
    },
    {
      img: "sciences.png",
      text: "Sciences",
      img: img2,
      subject: "crib",
      title: "Exploring the Wonders of Natural Sciences", // Added title
    },
    {
      img: "art.png",
      text: "Art & Humanities",
      subject: "mad",
      img: img3,
      title: "Unlocking Creativity: Art & Humanities Studies", // Added title
    },
  ];

  const [filterValues, setFilterValues] = useState({});
  const handleFilterChange = (e) => {
    setFilterValues((prev) => ({ ...prev, [e.name]: e.value }));
  };

  const subjects = ["All Subjects", "Commercial", "Sciences", "Art"];
  const [filteredCourses, setFilteredCourses] = useState(courses);

  // Filter courses based on the selected filters
  useEffect(() => {
    const applyFilter = (key, array, value) => {
      return value ? array?.filter((item) => item[key] === value) : array;
    };

    setFilteredCourses(() => {
      const classFiltered = applyFilter("class", courses, filterValues?.class);
      const subjectFiltered = applyFilter(
        "subject",
        classFiltered,
        filterValues?.subject
      );
      const categoryFiltered = applyFilter(
        "category",
        subjectFiltered,
        filterValues?.category
      );
      return applyFilter(
        "subCategory",
        categoryFiltered,
        filterValues?.subCategory
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues]);
  // pagination section
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 2;
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;
  const currentTableData = filteredCourses?.slice(
    firstPostIndex,
    lastPostIndex
  );
  // Calculate total pages
  const totalPosts = filteredCourses?.length;

  // Function to handle changing pages
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // const navigation = useNavigate();
  return (
    <Layout mqcolor="#00296B">
      <div className={styles.body}>
        <div className={styles.teachers_container}>
          <ERCText
            className={styles.teachers_text}
            color="#FFFFFF"
            weight="600"
            size="50px"
          >
            Special Needs Courses
          </ERCText>

          <div className={styles.home_text}>
            <ERCText color="#a3a3a3">Student Centre/ </ERCText>
            <ERCText color="#FFFFFF">Special Needs Courses</ERCText>
          </div>
          <div>
            <input
              className={styles.input}
              placeholder="Search your favorite course"
            />
          </div>
          <div className={styles.search}>
            <ERCButton width="120px" size="18px">
              Search
            </ERCButton>
          </div>

          <div className={styles.svg_container}>
            <div className={styles.svg1}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="213"
                height="317"
                viewBox="0 0 213 317"
                fill="none"
              >
                <path
                  d="M106.425 0C106.425 0 112.297 110.987 135.17 157.304C158.042 203.62 212.851 215.511 212.851 215.511C212.851 215.511 158.042 227.402 135.17 273.719C112.297 320.036 106.425 431.023 106.425 431.023C106.425 431.023 100.553 320.036 77.6808 273.719C54.8084 227.402 0 215.511 0 215.511C0 215.511 54.8084 203.62 77.6808 157.304C100.553 110.987 106.425 0 106.425 0Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg2}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="163"
                height="278"
                viewBox="0 0 163 278"
                fill="none"
              >
                <path
                  d="M81.7548 0.664062C81.7548 0.664062 86.2323 71.915 103.673 101.649C121.113 131.383 162.904 139.017 162.904 139.017C162.904 139.017 121.113 146.651 103.673 176.385C86.2323 206.119 81.7548 277.37 81.7548 277.37C81.7548 277.37 77.2774 206.119 59.8371 176.385C42.3969 146.651 0.605469 139.017 0.605469 139.017C0.605469 139.017 42.3969 131.383 59.8371 101.649C77.2774 71.915 81.7548 0.664062 81.7548 0.664062Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg3}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="214"
                height="326"
                viewBox="0 0 214 326"
                fill="none"
              >
                <path
                  d="M107.33 0.179688C107.33 0.179688 113.202 85.1327 136.074 120.585C158.947 156.037 213.755 165.139 213.755 165.139C213.755 165.139 158.947 174.241 136.074 209.693C113.202 245.145 107.33 330.098 107.33 330.098C107.33 330.098 101.458 245.145 78.5851 209.693C55.7127 174.241 0.904297 165.139 0.904297 165.139C0.904297 165.139 55.7127 156.037 78.5851 120.585C101.458 85.1327 107.33 0.179688 107.33 0.179688Z"
                  fill="white"
                  fill-opacity="0.25"
                />
              </svg>
            </div>
            <div className={styles.svg4}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="163"
                height="223"
                viewBox="0 0 163 223"
                fill="none"
              >
                <path
                  d="M81.2978 -208.525C81.2978 -208.525 85.7752 -97.5384 103.215 -51.2217C120.656 -4.90494 162.447 6.98596 162.447 6.98596C162.447 6.98596 120.656 18.8769 103.215 65.1936C85.7752 111.51 81.2978 222.497 81.2978 222.497C81.2978 222.497 76.8203 111.51 59.3801 65.1936C41.9398 18.8769 0.148438 6.98596 0.148438 6.98596C0.148438 6.98596 41.9398 -4.90494 59.3801 -51.2217C76.8203 -97.5384 81.2978 -208.525 81.2978 -208.525Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
            <div className={styles.svg5}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="208"
                height="199"
                viewBox="0 0 208 199"
                fill="none"
              >
                <path
                  d="M106.574 0.890625C106.574 0.890625 112.446 85.8436 135.318 121.296C158.191 156.748 212.999 165.85 212.999 165.85C212.999 165.85 158.191 174.952 135.318 210.404C112.446 245.856 106.574 330.809 106.574 330.809C106.574 330.809 100.702 245.856 77.8293 210.404C54.9568 174.952 0.148438 165.85 0.148438 165.85C0.148438 165.85 54.9568 156.748 77.8293 121.296C100.702 85.8436 106.574 0.890625 106.574 0.890625Z"
                  fill="white"
                  fill-opacity="0.1"
                />
              </svg>
            </div>
          </div>
        </div>
        {/* section 2 */}
        <div className={styles.coursesbody}>
          <div className="w-full md:flex-row flex flex-col gap-12">
            <div className="flex flex-col gap-6  md:w-[20%] w-full">
              <div>
                <ERCText width="228px" weight="700" size="24px" lHeight="32px">
                  Explore Courses For Special Needs
                </ERCText>
              </div>
              <div className={styles.filter}>
                <SideFilter
                  title={"Subjects"}
                  data={subjects}
                  name={"subject"}
                  onChange={handleFilterChange}
                  // defaultValue={selectedSubject}
                  viewAll
                />
              </div>
              <div className={styles.recommend}>
                <ERCText
                  align="justify"
                  size="16px"
                  weight="700"
                  lHeight="24px"
                >
                  Recommended Courses
                </ERCText>
                <div className="flex flex-col gap-4">
                  <RecommendedCourses
                    img={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946723/ERC/maths_vljukk.svg"
                    }
                    title={"Introduction To Further Mathematics For SS1"}
                    category={"Sciences"}
                  />
                  <RecommendedCourses
                    img={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946732/ERC/civic_kmiysm.svg"
                    }
                    title={"Introduction To Civic Education For JSS1"}
                    category={"Arts & Humanities"}
                  />
                  <RecommendedCourses
                    img={
                      "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718947254/ERC/biz-study_uai6sd.svg"
                    }
                    title={"Introduction To Business Studies For JSS1"}
                    category={"Commercial"}
                  />
                </div>
              </div>
            </div>
            <div className="md:w-[80%] w-full flex flex-col gap-6 ">
              <FilterComponent
                name={"category"}
                onChange={handleFilterChange}
                data={[
                  { value: "", display: "All Courses" },
                  {
                    value: "Educational Materials",
                    display: "Educational Materials",
                  },
                  {
                    value: "Special Needs School",
                    display: "Special Needs School",
                  },
                  { value: "Educative Games", display: "Educative Games" },
                ]}
                containerClass={styles.tags}
                render={(item) => <CourseTags tagName={item?.display} />}
              />
              <div className={styles.classes}>
                <ERCText size="24px" weight="700" lHeight="32px">
                  Special Needs Classes
                </ERCText>

                <div className="w-full grid gap-6 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 ">
                  {currentTableData.map((course, index) => (
                    <CourseCardSmall
                      key={index}
                      img={course.img}
                      text={course.text}
                      title={course.title}
                    />
                  ))}
                </div>
                <div className="w-full mt-6">
                  <PaginationSection
                    totalPosts={totalPosts}
                    postsPerPage={postsPerPage}
                    currentPage={currentPage}
                    setCurrentPage={handlePageChange}
                  />
                </div>
              </div>

              <div className={styles.therapy}>
                <ERCText size="24px" weight="700" lHeight="32px">
                  Audio And Visual Therapy
                </ERCText>
                <div className="w-full grid gap-6 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 ">
                  {/* <CourseCardSmall img={commercial} text={'Commercial'} /> */}
                  <CourseCardSmall
                    img={sciences}
                    text={"Sciences"}
                    title="Unlocking Creativity: Art & Humanities Studies"
                  />
                  <CourseCardSmall
                    img={art}
                    text={"Art & Humanities"}
                    title="Unlocking Creativity: Art & Humanities Studies"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.pag}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.5">
                <rect width="40" height="40" rx="5" fill="#F6B40A" />
                <path
                  d="M23.9502 14.2625L18.2252 20L23.9502 25.7375L22.1877 27.5L14.6877 20L22.1877 12.5L23.9502 14.2625Z"
                  fill="white"
                />
              </g>
            </svg>
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.625"
                y="0.625"
                width="38.75"
                height="38.75"
                rx="4.375"
                stroke="#FFD600"
                stroke-width="1.25"
              />
              <path
                d="M16.0498 14.2625L21.7748 20L16.0498 25.7375L17.8123 27.5L25.3123 20L17.8123 12.5L16.0498 14.2625Z"
                fill="#00296B"
              />
            </svg>
          </div>
        </div>

        <div className={styles.edugames}>
          <div className={styles.eduheader}>
            <div>
              <ERCText color="#00296B" size="14px" weight="700" lHeight="20px">
                EDUCATIONAL GAMES
              </ERCText>
              <hr style={{ border: "1.5px solid #FFD600", width: "60px" }} />
            </div>
            <ERCText width="348px" size="24px" weight="700" lHeight="32px">
              Special Educative Games and Resources
            </ERCText>
          </div>

          <div className="w-full grid gap-6 lg:grid-cols-4 md:grid-cols-3 grid-cols-2 py-12">
            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946724/ERC/scrabble_bauywa.svg"
              }
              title={"Scrabble Board Game"}
            />
            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718952323/ERC/pexels-monstera-6281878_1_cwv7zy.jpg"
              }
              title={"African Tour Game"}
            />
            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718952323/ERC/pexels-monstera-6281878_2_pzyvqs.jpg"
              }
              title={"Scrabble Board Game"}
            />
            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946723/ERC/3d_dice_f1agct.svg"
              }
              title={"3D Dice Game"}
            />
            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718951527/ERC/pexels-monstera-6281878_1_jifx66.svg"
              }
              title={"Attendance Sheet"}
            />

            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718951592/ERC/pexels-monstera-6281878_1_tontny.svg"
              }
              title={"Lesson Plan"}
            />

            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718946723/ERC/3d_dice_f1agct.svg"
              }
              title={"3D Dice Game"}
            />
            <GamesCard
              img={
                "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718951652/ERC/pexels-monstera-6281878_2_usuwdh.svg"
              }
              title={"Log Book"}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SpecialNeedsCourses;
